import { axiosInstance } from "../../../@core/auth/jwt/jwtService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const url = process.env.REACT_APP_URI;
const axios = require("axios");

export const getCheckoutOrderData = createAsyncThunk(
  "orders/getCheckoutOrderData",
  async (args, thunkAPI) => {
    const { eventId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/checkout`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las ordenes. Error: ",
        error.message
      );
    }
  }
);

export const setNewOrder = createAsyncThunk(
  "orders/setNewOrder",
  async (args, thunkAPI) => {
    const { eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders`,
      method: "post",
      data,
    });
    return { data: response.data };
  }
);

export const createOrderClip = (data) => {
  /* eslint-disable */
  const headers = {
    accept: "application/vnd.com.payclip.v1+json",
    "content-type": "application/json; charset=UTF-8",
    "x-api-key":
      "Basic ZTM3ZTg4ODUtOGU0MC00NzQ2LTk0NTUtODc0NzY0NDY1NmQ0OmQzZTAzNTFkLTA0MTctNDc0Yi1iMmJkLWM0ZTFlOTUzYTk3OA==",
  };

  axios
    .post("https://api-gw.payclip.com/paymentrequest", data, { headers })
    .then((response) => {
      console.log(response.data);
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getOrdersById = createAsyncThunk(
  "orders/getOrdersById",
  async (args, thunkAPI) => {
    const { id, eventId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/orders/${id}`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las ordenes. Error: ",
        error.message
      );
    }
  }
);

export const getOrders = createAsyncThunk(
  "orders/getOrders",
  async (args, thunkAPI) => {
    const {
      pageSize,
      pageNumber,
      searchQuery,
      eventId,
      status,
      orderBy,
      paymentMethod,
    } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/orders`,
        method: "get",
        params: {
          pageSize,
          pageNumber,
          searchQuery,
          status,
          orderBy,
          paymentMethod,
        },
      });
      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las Ordenes. Error: ",
        error.message
      );
    }
  }
);

export const getAllOrders = createAsyncThunk(
  "orders/getAllOrders",
  async (args, thunkAPI) => {
    const { eventId, status, paymentMethod } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders/export`,
      method: "get",
      params: { status, paymentMethod },
    });
    return { data: response.data };
  }
);

export const sendOrder = createAsyncThunk(
  "tickets/sendOrder",
  async (args, thunkAPI) => {
    const { id, email, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders/${id}/send`,
      method: "post",
      params: { email },
    });
    return { data: response };
  }
);

export const sendReminderOrder = createAsyncThunk(
  "tickets/sendReminderOrder",
  async (args, thunkAPI) => {
    const { id, email, eventId } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders/${id}/sendReminder`,
      method: "post",
      params: { email },
    });
    return { data: response };
  }
);

export const verifyOrder = async (id, eventId) => {
  -(await axiosInstance.get(
    `/events/${eventId}/orders/${id}/paymentStatus`,
    {}
  ));
};

export const confirmOrder = async (id, eventId) => {
  await axiosInstance.post(`/events/${eventId}/orders/${id}/confirm`, "", {});
};

export const setOrder = async (data) => {
  await axiosInstance.post(url, data);
};

export const deleteOrder = async (orderId, eventId) => {
  await axiosInstance.delete(`/events/${eventId}/orders/${orderId}`, "");
};

export const updateOrder = createAsyncThunk(
  "tickets/updateOrder",
  async (args, thunkAPI) => {
    const { orderId, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/orders/${orderId}`,
      method: "patch",
      data,
    });
    return { data: response };
  }
);

export const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    list: [],
    listId: [],
    totalRows: 0,
    pending: false,
    currentMail: "",
    inputSearch: "",
    checkoutData: {},
    orderTickets: [],
    listToExport: [],
    confirmStatus: 0,
    loadingStatus: "",
    pendingById: false,
    pendingSend: false,
    pendingExport: false,
    pendingUpdate: false,
    pendingSetOrder: false,
    resendShowModal: false,
    pendingSendOrder: false,
  },
  reducers: {
    setOrdersList: (state, action) => {
      state.list = action.payload;
    },
    setInputSearch: (state, action) => {
      state.inputSearch = action.payload;
    },
    addTicketToOrder: (state, action) => {
      state.orderTickets = [...state.orderTickets, action.payload];
    },
    removeTicketFromOrder: (state, action) => {
      const newOrderTickets = state.orderTickets.filter(
        (ticket) => ticket.id !== action.payload
      );
      state.orderTickets = [...newOrderTickets];
    },
    clearTicketsFromOrder: (state) => {
      state.orderTickets = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.fulfilled, (state, action) => {
        const { data } = action.payload;
        const keys = [];
        data?.data.forEach((e, i) => {
          if (e.customFields) {
            keys.push(e.customFields);
          }
        });

        const result = [...new Set(keys.flatMap(Object.keys))];
        state.headers = result;
        state.list = data;
        state.loadingStatus = "succeeded";
        state.pending = false;
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getOrders.pending, (state) => {
        state.pending = true;
      })
      .addCase(getOrders.rejected, (state) => {
        state.loadingStatus = "failed";
        state.list = [];
        state.pending = false;
      })
      .addCase(getCheckoutOrderData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.checkoutData = data;
        state.loadingStatus = "succeeded";
      })
      .addCase(getCheckoutOrderData.rejected, (state) => {
        state.loadingStatus = "failed";
      })
      .addCase(getOrdersById.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listId = data;
        state.pendingById = false;
      })
      .addCase(getOrdersById.pending, (state) => {
        state.pendingById = true;
      })
      .addCase(getOrdersById.rejected, (state) => {
        state.pendingById = true;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.listToExport = data;
        state.pendingExport = false;
      })
      .addCase(getAllOrders.pending, (state) => {
        state.pendingExport = true;
      })
      .addCase(getAllOrders.rejected, (state) => {
        state.pendingExport = false;
      })
      .addCase(setNewOrder.fulfilled, (state) => {
        state.pendingSetOrder = false;
      })
      .addCase(setNewOrder.pending, (state, action) => {
        state.pendingSetOrder = true;
      })
      .addCase(setNewOrder.rejected, (state) => {
        state.pendingSetOrder = false;
      })
      .addCase(sendReminderOrder.fulfilled, (state) => {
        state.pendingSend = false;
      })
      .addCase(sendReminderOrder.pending, (state, action) => {
        state.pendingSend = true;
      })
      .addCase(sendReminderOrder.rejected, (state) => {
        state.pendingSend = false;
      })
      .addCase(sendOrder.fulfilled, (state) => {
        state.pendingSendOrder = false;
      })
      .addCase(sendOrder.pending, (state, action) => {
        state.pendingSendOrder = true;
      })
      .addCase(sendOrder.rejected, (state) => {
        state.pendingSendOrder = false;
      })
      .addCase(updateOrder.fulfilled, (state) => {
        state.pendingUpdate = false;
      })
      .addCase(updateOrder.pending, (state, action) => {
        state.pendingUpdate = true;
      })
      .addCase(updateOrder.rejected, (state) => {
        state.pendingUpdate = false;
      });
  },
});

export const {
  setOrdersList,
  setInputSearch,
  addTicketToOrder,
  removeTicketFromOrder,
  clearTicketsFromOrder,
} = ordersSlice.actions;

export default ordersSlice.reducer;
